import {Action} from "@ngrx/store";

export const ADD_LOGBOOK_ENTRY = '[LogbookSaving] Add logbook entry';

export class AddLogbookEntry implements Action {
    readonly type = ADD_LOGBOOK_ENTRY;
}
